var theme = {
    init : function(){
        theme.Modal();
        theme.changeQuantity();
        theme.productViewType();
    },
    Modal : function(){
        $('.close-cart-popup,.overlay-cart').on('click',function(e){
            e.preventDefault();
            $('.cart-popup-container').removeClass('active');
            $('body').removeClass('overflow-hidden');
        })

        $('.close-newsletter-popup,.overlay-newsletter').on('click',function(e){
            e.preventDefault();
            $('.newsletter-container').removeClass('active');
            var not_show = $('#notshow').is(':checked');
            if (not_show == true) {
                setCookie('_news_not_show','hide',60);
            }
        });
        var notshow_cookie = getCookie('_news_not_show');
        if (notshow_cookie != 'hide') {
            setTimeout(function(){
                $('.newsletter-container').addClass('active');
            },3000)
        }
    },
    changeQuantity : function(){
        $(document).on('click','.minus',function(){
            var num  = parseInt($(this).parent().find('#number').val()) > 0 ? parseInt($(this).parent().find('#number').val()) - 1 : 0;
            $(this).parent().find('#number').val(num);
        })
        $(document).on('click','.plus',function(){
            var num = parseInt($(this).parent().find('#number').val()) + 1;
            $(this).parent().find('#number').val(num);
        })
    },
    productViewType : function(){
       var type = getCookie('_view_type');
       $('.product-view-type').removeClass('active');
       if(type != false){
           $('.product-view').removeClass('grid-product').addClass(type);
           $('[data-type="'+type+'"]').addClass('active');
       }else{
           $('.product-view').addClass('grid-product');
           $('[data-type="grid-product"]').addClass('active');
       }
       $(document).on('click','.product-view-type',function(e){
            e.preventDefault();
            var type = $(this).data('type');
            $(this).siblings('.product-view-type').removeClass('active');
            $(this).addClass('active');

            if(type == 'list-product'){
               $('.product-view').addClass(type).removeClass('grid-product');
            }else{
               $('.product-view').addClass(type).removeClass('list-product');
            }
            masonryReloadLayout();
            setCookie('_view_type',type,60);
       })
   }
}
theme.init();
$(document).ready(function(){
    $('.item-has-children').append('<span class="toggle-button"></span>');

    $('.mobile-menu-btn').click(function(e){
        e.preventDefault();
        $('.main-menu').find('.main-nav').slideToggle();
    });

    $('.toggle-button').click(function(e){
        e.preventDefault();
        $(this).parent().find('> .children-toggle').toggleClass('children-open');
        $(this).parent().find('> .children-toggle').slideToggle();
    });

    $(".top-level-link.item-has-children").mouseover(function(){
        $(this).addClass('hover');
    });

    $(".top-level-link.item-has-children").mouseleave(function(){
        $(this).removeClass('hover');
    });
});

//countdown
function show_countdown(start_time, end_time) {
    var countdownfunction = setInterval(function() {
      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now an the count down date
      var distance = end_time - now;
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result in an element with id="demo"
      var days_format = ((days<10)?"0":"") + days;
      var hours_format = ((hours<10)?"0":"") + hours;
      var minutes_format = ((minutes<10)?"0":"") + minutes;
      var seconds_format = ((seconds<10)?"0":"") + seconds;
      var time_range = end_time - start_time;
      if(time_range > 0){
        $("p.days").html(days_format);
        $("p.hours").html(hours_format);
        $("p.minutes").html(minutes_format);
        $("p.seconds").html(seconds_format);
      }else{
        $(".countdown-time").hide();
      }
      
      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(countdownfunction);
        $(".countdown-time").html("<p class='endded'></p>");
      }
    }, 1000);   
}

$(document).ready(function(){
   // Set the date we're counting down to
    var start_time = new Date( $(".countdown-time").data("start") ).getTime();
    var end_time = new Date( $(".countdown-time").data("end") ).getTime();
    var test = new Date( start_time ).getTime();
    show_countdown(start_time, end_time);
});

/*----------for layout1-------------*/
$(document).ready(function(){
    var loop = true;
    $('.banner-slider.layout1').owlCarousel({
        margin:0,
        responsiveClass:true,
        dots:true,
        dotsEach: 1,
        dotsSpeed:800,
        navSpeed:800,
        autoplay:false,
        autoplaySpeed:1200,
        loop: loop,
        mouseDrag : true,
        nav:true,
        navText: [$('.slider-prev'),$('.slider-next')],
        responsive:{
              0:{
                  items:1
              },
              768:{
                  items:1
              },
              992:{
                  items:1
              }
          }
    })

});

/*----------slide for sidebar-------------*/
$(document).ready(function(){
    var loop = false;
    $('.banner-slider.for-sidebar').owlCarousel({
        margin:0,
        responsiveClass:true,
        dots:true,
        dotsEach: 1,
        dotsSpeed:800,
        loop: loop,
        mouseDrag : false,
        responsive:{
              0:{
                  items:1
              },
              768:{
                  items:1
              },
              992:{
                  items:1
              }
          }
    })

});

/*----------Blogs carousel-------------*/
$(document).ready(function(){
    $('.blogs-carousel').owlCarousel({
        margin:25,
        responsiveClass:true,
        dots:true,
        dotsEach: 3,
        dotsSpeed:400,
        navSpeed:600,
        autoplay:false,
        autoplaySpeed:1200,
        loop: false,
        mouseDrag : true,
        nav:false,
        navText: [$('.blog-prev'),$('.blog-next')],
        responsive:{
              0:{
                  items:1
              },
              768:{
                  items:2
              },
              992:{
                  items:3
              }
          }
    })

});

/*----------Banner carousel background-------------*/
$(document).ready(function(){
    $('.banner-carousel_slide').owlCarousel({
        dots:false,
        autoplay:true,
        autoplayTimeout: 8000,
        autoplaySpeed:1200,
        dragEndSpeed:1200,
        loop: true,
        mouseDrag : true,
        nav:false,
        items:1
    })

});

/*----------Banner carousel collection-------------*/
$(document).ready(function(){
    $('.banner-carousel_collection').owlCarousel({
        margin:40,
        responsiveClass:true,
        dots:true,
        dotsEach: 1,
        dotsSpeed:400,
        navSpeed:600,
        autoplay:false,
        autoplaySpeed:1200,
        loop: false,
        mouseDrag : true,
        nav:false,
        navText: [$('.banner-prev'),$('.banner-next')],
        responsive:{
              0:{
                  items:1
              },
              600:{
                  items:2
              }
          }
    })

});

$(document).ready(function(){
    $('.mid-banner-carousel').owlCarousel({
        responsiveClass:true,
        dots:true,
        dotsEach: 1,
        dotsSpeed:800,
        navSpeed:800,
        autoplay:false,
        autoplaySpeed:1200,
        loop: true,
        mouseDrag : true,
        nav:false,
        responsive:{
              0:{
                  items:1
              },
              768:{
                  items:1
              },
              992:{
                  items:1
              }
          }
    })

});

/*----------Services carousel-------------*/
$(document).ready(function(){
    $('.services-carousel').owlCarousel({
        margin:20,
        responsiveClass:true,
        dots:true,
        dotsEach: 2,
        dotsSpeed:400,
        navSpeed:600,
        autoplay:false,
        autoplaySpeed:1200,
        loop: true,
        mouseDrag : true,
        nav:false,
        navText: [$('.service-prev'),$('.service-next')],
        responsive:{
              0:{
                  items:1
              },
              575:{
                  items:2
              },
              768:{
                  items:3
              }
          }
    })

});

/*----------Videos carousel-------------*/
$(document).ready(function(){
    $('.videos-carousel').owlCarousel({
        margin:30,
        responsiveClass:true,
        dots:true,
        dotsEach: 1,
        dotsSpeed:400,
        navSpeed:600,
        autoplay:false,
        autoplaySpeed:1200,
        loop: true,
        mouseDrag : false,
        nav:false,
        responsive:{
              0:{
                  items:1
              },
              768:{
                  items:2
              }
          }
    })

});

/*----------Related product carousel-------------*/
$(document).ready(function(){
    $('.product-images-carousel').owlCarousel({
        margin:30,
        responsiveClass:true,
        dots:false,
        dotsEach: 1,
        dotsSpeed:400,
        navSpeed:600,
        autoplay:false,
        autoplaySpeed:1200,
        loop: true,
        mouseDrag : true,
        nav:true,
        navText: [$('.product-images-prev'),$('.product-images-next')],
        responsive:{
              0:{
                  items:1
              },
              768:{
                  items:2
              },
              992:{
                  items:3
                  
              }
          }
    })

});

/*----------Related product carousel-------------*/
$(document).ready(function(){
    $('.related-product-carousel').owlCarousel({
        margin:25,
        responsiveClass:true,
        dots:false,
        dotsEach: 1,
        dotsSpeed:400,
        navSpeed:600,
        autoplay:false,
        autoplaySpeed:1200,
        loop: true,
        mouseDrag : true,
        nav:true,
        navText: [$('.related-prev'),$('.related-next')],
        responsive:{
              0:{
                  items:1
              },
              768:{
                  items:2
              },
              992:{
                  items:4
                  
              },
              1200:{
                  items:5
                  
              }
          }
    })

});


//slick image single product
function initSingle(large, small) {
    $(document).find(small).each(function() {
        var id = $(this).data('id');
        var small = '.small-image-' + id;
        var large = '.large-image-' + id;
        if ($(this).data('vertical') == true) {
            var vertical = true;
            var verticalS = true;
        } else {
            var vertical = false;
            var verticalS = false;
        }

        if ($(this).data('dots') == true) {
            var dots = true;
        } else {
            var dots = false;
        }

        if ($(this).data('center') == true) {
            var center = true;
        } else {
            var center = false;
        }

        if (typeof $(this).data('number') !== 'undefined') {
            var number = $(this).data('number');
        } else {
            var number = 3;
        }
        $(small).not('.slick-initialized').slick({
            slidesToShow: number,
            slidesToScroll: 1,
            asNavFor: large,
            focusOnSelect: true,
            vertical: vertical,
            verticalSwiping: verticalS,
            centerMode: center,
            centerPadding: '0',
            arrows: true,
            dots: dots,
            prevArrow: '<span class="prev"><i class="fas fa-angle-left"></i></span>',
            nextArrow: '<span class="next"><i class="fas fa-angle-right"></i></span>'
        });
    });
    $(document).find(large).each(function() {
        var id = $(this).data('id');
        var small = '.small-image-' + id;
        var large = '.large-image-' + id;
        $(large).not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: small
        });
    });
}
initSingle('.large-image','.small-image');

//Masonry active
function masonryLoad() {
    $(document).ready(function() {
        $('.masonry-grid').imagesLoaded(function(){                       
            $('.masonry-grid').masonry({
                itemSelector: '.grid-item'
            });    
        });
    });
    
}
function masonryReloadAjax() {
    $('.masonry-grid').imagesLoaded(function(){      
        $('.masonry-grid').masonry({
            itemSelector: '.grid-item'
        }); 
        $('.masonry-grid').masonry( 'reloadItems' );
        $('.masonry-grid').masonry( 'layout' );
    });
}

function masonryReloadLayout() {
    $('.masonry-grid').masonry({
        itemSelector: '.grid-item'
    });
}
  
masonryLoad();

// with sizer
$(document).ready(function() {
  $('.masonry-grid-sizer').imagesLoaded(function(){                       
      $('.masonry-grid-sizer').masonry({
          itemSelector: '.grid-item',
          columnWidth: '.grid-sizer'
      });    
  });
});

//gallery
function gallery(){
    $(document).on('click','.show-gallery',function(e){
        e.preventDefault();
        $(this).parents('.single-product-image').find('.click img').trigger('click');
    })
    $(document).find('.gallery-images').each(function() {
        var id = $(this).data('id');
        lightGallery(document.getElementById(id), {
            thumbnail:true,
            animateThumb: false,
            showThumbByDefault: false
        });
    });
}
gallery();

/*----------instagram photo-------------*/
$(document).ready(function(){
    var social = {
        init : function () {
            social.getInsImage();
        },
        getInsImage : function(){
            if ((typeof user_id !== 'undefined')&&(typeof access_token !== 'undefined')) {
                $.ajax({
                    method: 'GET',
                    url: 'https://api.instagram.com/v1/users/'+user_id+'/media/recent/?access_token='+access_token,
                    error: function(response){
                        Console.log(response.message);
                    },
                    success: function (response) {
                        if(response.meta.code == 200){
                            social.showImage(response);
                            console.log("done");
                            return;
                        }
                        Console.log(response.message);
                    },
                    dataType: 'jsonp'
                });
            }    
        },
        showImage : function(data){
            var html = '';
            $.each(data.data,function(i,e){
                html +='<div class="item"><a href="'+e.link+'"><img src="'+e.images.low_resolution .url+'" alt=""><div class="item-overlay"><i class="fa fa-eye"></i></div></a></div>';
                return i<photos_limit-1;    
            });
            social.build(html);
        },
        build : function(html){
            $('.instagram-image').html(html); 
        }
    }
    if(template == 'index' || template == 'blog'|| template == 'article') {
        social.init();
    }

});


/*----------Show sharing-----------*/
$(document).ready(function(){
    $('a.show-sharing').on("click", function(){
        var effect = 'slide';
        // Set the options for the effect type chosen
        var options = { direction: 'right' };
        // Set the duration (default: 400 milliseconds)
        var duration = 400;
        $(this).parents('.sharing-wrap').find('.social-sharing').toggle(effect, options, duration);
    });
});


/*----------Tooltip-----------*/
$(document).ready(function() {
    $("body").tooltip({
      selector: '[data-toggle=tooltip]',
      trigger : 'hover'
    });
});

// /*----------Back to top -----------*/

// //Make sure the user has scrolled at least double the height of the browser
// var toggleHeight = $(window).outerHeight() * 2;
// $(window).scroll(function() {
//   if ($(window).scrollTop() > toggleHeight) {
//     //Adds active class to make button visible
//     $(".m-backtotop").addClass("active");
    
//     //Just some cool text changes
//     $('h1 span').text('TA-DA! Now hover it and hit dat!')
    
//   } else {
//     //Removes active class to make button visible
//     $(".m-backtotop").removeClass("active");
    
//     //Just some cool text changes
//     $('h1 span').text('(start scrolling)')
//   }
// });


//Scrolls the user to the top of the page again
$(".m-backtotop").click(function() {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
});


/*----------Isotope filter tab-----------*/
$(document).ready(function(){
    $grid = $('.filter-grid').isotope({
        // options
        itemSelector: '.grid-item',
        animationEngine: 'best-available',
        transitionDuration: '0.5s',
        layoutMode: 'masonry',
        hiddenStyle: {
          opacity: 0
        },
        visibleStyle: {
          opacity: 1
        },
        masonry: {
          gutter: 0
        }
    });
    // fist-load. $grid.isotope({ filter: '*' });
    var fist_load_class = $('.button-filter button.active').attr('data-filter');
    $grid.isotope({ filter: fist_load_class });

    // filter items on button click
    $('.button-filter').on( 'click', 'button', function() {
        var filterValue = $(this).attr('data-filter');
        $grid.isotope({ filter: filterValue });
        $( '.button-filter button' ).removeClass( 'active' );
        $( this ).addClass( 'active' );

        var button_show = '.show-more' + filterValue;
        $('.show-more').removeClass('active');
        $(button_show).addClass('active');
    });

    $(".collection-filter-section .show-more").on('click','>a',function(event) {
        event.preventDefault();
        var type_item = $(this).data('type');
        $(this).children('i').addClass('loading');
        if (!$(this).hasClass("disable")) {
            var scrollURL = $('.show-more a').attr("href");
            $.ajax({
                type: "GET",
                url: scrollURL,
                success: function(data) {
                    if ($(data).find(".filter-grid").length > 0) {
                        var find_class = '.filter-grid .product-infor.' + type_item;
                        $(data).find(find_class).each(function() {
                            $('.filter-grid').append($(this)).isotope('appended',$(this));
                            $( ".button-filter button.active").trigger('click');
                        });

                        var show_more = '.show-more.'+type_item;
                        if($(data).find(show_more).length > 0){
                            $(show_more).html($(data).find(show_more).html());
                        }else{
                            $(show_more).find('a').addClass('disable');
                            $(show_more).remove();
                        }
                        $('.show-more').find('i').removeClass('loading');
                    }
                    data = null;
                },
                error: function(XMLHttpRequest, textStatus) {
                    obj.hidePreloader();
                    alert("error1");
                },
                dataType: "html"
            })
        }
    })
});


// // mouse Position
// var m_x = null;
// var m_y = null;
    
// document.addEventListener('mousemove', onMouseUpdate, false);
// document.addEventListener('mouseenter', onMouseUpdate, false);
    
// function onMouseUpdate(e) {
//     m_x = e.pageX;
//     m_y = e.pageY;
// }

// function getMouseX() {
//     return m_x;
// }

// function getMouseY() {
//     return m_y;
// }

$(document).ready(function(){
    if ( $("body").hasClass("template-product") && $('.single-product-view').hasClass("layout1")){
        // fixed scroll template product
        // init constant value
        var left_height = $('.scroll-left').outerHeight();
        var right_height = $('.scroll-right').outerHeight();
        var action_bar_height = $('.action-bar').outerHeight();
        var header_height = $('.header-section').outerHeight();
        var initial_height = action_bar_height + header_height;
        var height_active = left_height - right_height + initial_height
        var scroll_max_margin = (left_height - right_height);
        $(window).scroll(function(e) {
            if (window.innerWidth > 1200) {
                var current_scrolled = $(this).scrollTop();// number pixel scrolled.
                if ( (current_scrolled > initial_height) && (current_scrolled < height_active) ){//start action.
                    $('.scroll-right').removeAttr('style');
                    $('.scroll-right').addClass('right-fixed');
                }else{
                    $('.scroll-right').removeAttr('style');
                    $('.scroll-right').removeClass('right-fixed');
                    if (current_scrolled > height_active) {
                        $('.scroll-right').css('margin-top', scroll_max_margin);
                    }
                }
            }else{
                $('.scroll-right').removeAttr('style');
            }
        });
    }
});

/*----------Toggle down content-----------*/
$(document).ready(function() {
    $('.toggle-down').on("click", function(){
        var $this = $(this);
        var toggle_content = $this.parent().find('.toggle-content');
        if ($(toggle_content).is(':hidden')) {
            $this.find('i.fas.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
            $this.find('i.fas.fa-plus').removeClass('fa-plus').addClass('fa-minus');
            $this.find('i.fas.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-up');
            $this.addClass('active');
            $this.parent().find('a.handle').addClass('active');
        } else {
            $this.find('i.fas.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
            $this.find('i.fas.fa-minus').removeClass('fa-minus').addClass('fa-plus');
            $this.find('i.fas.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $this.removeClass('active');
            $this.parent().find('a.handle').removeClass('active');
        }
        //https://jqueryui.com/toggle/
        var effect = 'blind';
        if (typeof $this.data('effect') !== 'undefined') {
            effect = $this.data('effect');
        }

        var duration = 400;
        if (typeof $this.data('duration') !== 'undefined') {
            duration = $this.data('duration');
        }
        $(toggle_content).toggle(effect, duration);
    });

    $('.close-toggle').on("click", function(){
        $(this).parent().hide();
    });
});

/*----------Apply code-----------*/
$(document).ready(function() {
    $(document).on('click', '.apply-code', function(e){
        var $this = $(this);
        $this.find('>i').addClass('loading');
        setTimeout(function(){
            $this.empty();
            $this.removeClass('apply-code')
            $this.html('<i class="fas fa-check"></i>');
        },800)
    });
});

/*----------Video click-----------*/
$(document).ready(function() {
    $(document).on('click', '.video-item .item-overlay', function(e){
        $(this).hide();
    });
});


